/* eslint-disable no-template-curly-in-string */
import LoaderService from '../Loader/loader.service';

interface RenderService {
  loadFormRenderJSON(healthplan: any, serviceType: any, patientType: any): Promise<any>;
}

const renderService: RenderService = {
  loadFormRenderJSON: async (healthplan, serviceType, patientType) => {
    try {
      const json = await LoaderService.getFormJSON(healthplan, serviceType, patientType);
      return json;
    } catch (error) {
      throw new Error('Error loading JSON : ${error}');
    }
  },
};

export default renderService;
